'use client'

import React from 'react'
import StepperControl from '~/components/ui/stepper-control'

import { useLocale } from '~/contexts/LocaleContext'
import { getTranslation } from '~/lib/i18n-utils'
interface GuestInputProps {
  label: string
  note: string
  value: number
  setValue: (v: number) => void
  minValue?: number
}

function GuestInput({ label, note, value, setValue, minValue = 0 }: GuestInputProps) {
  return (
    <div className="flex items-center justify-between">
      <div className="text-sm">
        <div className="font-lexend text-[12px] font-medium text-[#2D2E32]">{label}</div>
        <div className="font-lexend text-[10px] text-xs text-[#666B74]">{note}</div>
      </div>
      <StepperControl
        value={value}
        min={minValue}
        max={10}
        onDecrement={() => setValue(value - 1)}
        onIncrement={() => setValue(value + 1)}
        onChange={(val) => {
          setValue(val)
        }}
      />
    </div>
  )
}

interface GuestCardProps {
  adults: number
  kidsOver6: number
  kidsUnder6: number
  minAdults: number
  minKidsOver6: number
  minKidsUnder6: number
  setAdults: (value: number) => void
  setKidsOver6: (value: number) => void
  setKidsUnder6: (value: number) => void
  onApply: () => void
}

export default function GuestCard({
  adults,
  kidsOver6,
  kidsUnder6,
  minAdults,
  minKidsOver6,
  minKidsUnder6,
  setAdults,
  setKidsOver6,
  setKidsUnder6,
}: GuestCardProps) {
  const { locale } = useLocale()
  const t = getTranslation(locale)
  return (
    <div className="w-full space-y-2">
      <h3 className="font-lexend text-base font-medium text-secondary-950">
        {t('booking.guestCount')}
      </h3>
      <div className="my-2 h-[1px] w-full bg-[#F3F3F3]"></div>
      <div className="space-y-2">
        <GuestInput
          label={t('booking.adults')}
          note={t('booking.adultsDesc')}
          value={adults}
          setValue={setAdults}
          minValue={minAdults}
        />
        <GuestInput
          label={t('booking.childrenOver6')}
          note={t('booking.childrenOver6Desc')}
          value={kidsOver6}
          setValue={setKidsOver6}
          minValue={minKidsOver6}
        />
        <GuestInput
          label={t('booking.childrenUnder6')}
          note={t('booking.childrenUnder6Desc')}
          value={kidsUnder6}
          setValue={setKidsUnder6}
          minValue={minKidsUnder6}
        />
      </div>
    </div>
  )
}
